import React from "react";
import Skeleton from "react-loading-skeleton";
// import information from "../images/informaton.svg";
// import Slider from "react-slick";
import {
  Card,
  Col,
  Container,
  Form,
  Nav,
  Row,
  Tab,
  Table,
} from "react-bootstrap";
import "react-loading-skeleton/dist/skeleton.css";
import profileicon from "../../assets/images/dummy-profile-pic.jpg";
import { Link, useLocation } from "react-router-dom";
// import { ReactComponent as NoDataFound } from "../src/assets/Icons/no-record-found.svg";
// import { ReactComponent as NoDataFoundWhite } from "../src/assets/Icons/no-record-found-white.svg";
export const LoaderType = {
  Table: "Table",
  Line: "Line",
  Widgets: "Widgets",
  NewCardWidgets: "NewCardWidgets",
  MachineCardLoader: "MachineCardLoader",
  SourceCode: "SourceCode",
  MarketHeader: "MarketHeader",
  MarketMainLeft: "MarketMainLeft",
  MarketMainRight: "MarketMainRight",
  ProjectCard: "ProjectCard",
  ReviewDetailHeading: "ReviewDetailHeading",
  ReviewDetailLeft: "ReviewDetailLeft",
  ReviewDetailRight: "ReviewDetailRight",
  CompleteProfile: "CompleteProfile",
  NumberCount: "NumberCount",
  DeveloperHeader: "DeveloperHeader",
  DeveloperLeft: "DeveloperLeft",
  DeveloperMain: "DeveloperMain",
  TableRow: "TableRow",
  FileContent: "FileContent",
  Files: "Files",
  WorkFlowContacts: "WorkFlowContacts",
  CasedetailWorkFlowContacts: "CASEDETAILWORKFLOWCONTACTS",
  AIGenerateModal: "AIGenerateModal",
  SupportDetail: "SupportDetail",
  SupportFilters: "SupportFilters",
  SupportSetting: "SupportSetting",
  NotificationList: "NotificationList",
  NotificationSetting: "NotificationSetting",
  AllMachineWidget: "AllMachineWidget",
  AllAnnouncements: "AllAnnouncements",
  DashBlockData: "DashBlockData",
  CostWidget: "CostWidget",
  PriceType: "PriceType",
  ChartLine: "ChartLine",
  DailyActivityChartLine: "DailyActivityChartLine",
  AiEnhancedMachine: "AiEnhancedMachine",
  ChartThinLine: "ChartThinLine",
  PaymentMethodCard: "PAYMENTMETHODCARD",
  PaymentMethodSingleCard: "PAYMENTMETHODSINGLECARD",
  PaymentNextBilling: "PAYMENTNEXTBILLING",
  Machine360Header: "Machine360Header",
  Machine360Sidebar: "Machine360Sidebar",
  Machine360Kpi: "Machine360Kpi",
  Machine360Page: "Machine360Page",
  WorkflowSummary: "WorkflowSummary",
  WorkflowCostSummary: "WorkflowCostSummary",
};

function Loader(prop) {
  var projectslider = {
    autoplay: false,
    autoplaySpeed: 5000,
    pauseOnFocus: true,
    pauseOnHover: true,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 2,
    draggable: true,
    variableWidth: true,
    slide: ".black-card",
    centerMargin: "15px",
  };
  let count = prop.count || 4;
  let type = prop.type || "Line";
  let lineheight = prop.lineheight || 30;
  let height = prop.height || "100%";
  let width = prop.width || "100%";
  let color = prop.color || "#000000";
  let nooftd = prop.nooftd || 1;
  let location = useLocation();

  let line = [];
  for (let i = 0; i < count; i++) {
    line.push(i);
  }

  let td = [];
  for (let i = 0; i < nooftd; i++) {
    td.push(i);
  }

  if (type.toUpperCase() === "TABLE") {
    return (
      <div className="table-wrapper-main">
        <Table>
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {line.map((item, index) => (
              <tr key={index}>
                <td>
                  <Skeleton height={lineheight} />
                </td>
                <td>
                  <Skeleton height={lineheight} />
                </td>
                <td>
                  <Skeleton height={lineheight} />
                </td>
                <td>
                  <Skeleton height={lineheight} />
                </td>
                <td>
                  <Skeleton height={lineheight} />
                </td>
                <td>
                  <Skeleton height={lineheight} />
                </td>
                <td>
                  <Skeleton height={lineheight} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  } else if (type.toUpperCase() === "WIDGETS") {
    return (
      <>
        <div className="all-market-place-main">
          {line.map((item, index) => (
            <div
              key={index}
              className="single-market-place-main d-flex justify-content-between flex-column"
            >
              <div>
                <div className="d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex gap-2 align-items-center">
                    <div className="single-market-place-img">
                      <Skeleton height={34} width={34} circle={true} />
                    </div>
                    <div className="market-place-content-title">
                      <Skeleton height={20} width={170} />
                    </div>
                  </div>
                  <h3 className="report-price-single">
                    <Skeleton height={22} width={55} />
                  </h3>
                </div>
                <div>
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <span className="blue-badge">
                      <Skeleton height={5} width={50} />
                    </span>
                    <div className="market-place-content-title">
                      <div className="market-place-content-ratings">
                        <Skeleton height={7} width={7} />
                        <span>
                          <Skeleton height={7} width={14} />
                        </span>
                      </div>
                      {/* <h4>
                    <Skeleton height={20} width={100} />
                  </h4> */}
                    </div>
                  </div>
                  <p>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </p>
                </div>
              </div>
              <div className="market-place-content">
                <div className="d-flex align-items-end justify-content-between">
                  <div className="developer-name">
                    <Skeleton height={15} width={55} />
                    <Skeleton height={20} width={100} />
                  </div>
                  <Link
                    // to={`${`/marketplace/marketplace-detail/${item_m?.machineid}`}`}
                    className="crossarrow ms-auto"
                  >
                    <Skeleton height={34} width={34} circle={true} />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  } else if (type.toUpperCase() === "NEWCARDWIDGETS") {
    return (
      <>
        <div className="all-market-place-main">
          {line.map((item, index) => (
            <div key={index} className="single-market-place-main new-single-market-place-main cursor-pointer w-100">
              <div className="single-market-place-img">
                <Skeleton height={60} width={60} circle={true} />
              </div>

              <div className="machine-card-right-content w-100">
                <h4>
                  <Skeleton height={20} width={180} />
                </h4>

                <div className="rating-user-box">
                  <span className="blue-badge">
                    <Skeleton height={12} width={40} />
                  </span>

                  <div className="market-place-content-ratings d-flex align-items-center gap-1">
                    <Skeleton height={14} width={14} />
                    <Skeleton height={14} width={14} />
                    <Skeleton height={14} width={14} />
                    <Skeleton height={14} width={14} />
                    <Skeleton height={14} width={14} />
                    <span>
                      <Skeleton height={14} width={30} />
                    </span>
                  </div>
                </div>

                <span className="w-100 d-block">
                  <Skeleton height={12} width={"100%"} />
                  <Skeleton height={12} width={"100%"} />
                </span>

                <span className="developer-box d-flex align-items-center gap-2">
                  <Skeleton height={20} width={20} circle={true} />
                  <Skeleton height={16} width={120} />
                </span>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  } else if (type.toUpperCase() === "MACHINECARDLOADER") {
    return (
      <>
        {/* <div className="all-market-place-main"> */}
        {line.map((item, index) => (
          <div
            key={index}
            className="single-market-place-main d-flex justify-content-between flex-column"
          >
            <div>
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="d-flex gap-2 align-items-center">
                  <div className="single-market-place-img">
                    <Skeleton height={34} width={34} circle={true} />
                  </div>
                  <div className="market-place-content-title">
                    <Skeleton height={20} width={170} />
                  </div>
                </div>
                <h3 className="report-price-single">
                  <Skeleton height={22} width={55} />
                </h3>
              </div>
              <div>
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <span className="blue-badge">
                    <Skeleton height={5} width={50} />
                  </span>
                  <div className="market-place-content-title">
                    <div className="market-place-content-ratings">
                      <Skeleton height={7} width={7} />
                      <span>
                        <Skeleton height={7} width={14} />
                      </span>
                    </div>
                    {/* <h4>
                    <Skeleton height={20} width={100} />
                  </h4> */}
                  </div>
                </div>
                <p>
                  <Skeleton height={20} width={"100%"} />
                  <Skeleton height={20} width={"100%"} />
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
            </div>
            <div className="market-place-content">
              <div className="d-flex align-items-end justify-content-between">
                <div className="developer-name">
                  <Skeleton height={15} width={55} />
                  <Skeleton height={20} width={100} />
                </div>
                <Link
                  // to={`${`/marketplace/marketplace-detail/${item_m?.machineid}`}`}
                  className="crossarrow ms-auto"
                >
                  <Skeleton height={34} width={34} circle={true} />
                </Link>
              </div>
            </div>
          </div>
        ))}
        {/* </div> */}
      </>
    );
  } else if (type.toUpperCase() === "MARKETHEADER") {
    return (
      <>
        {line.map((item, index) => (
          <div
            key={index}
            className="d-flex align-items-center justify-content-between w-100 mb40"
          >
            <div className="top-left-sect-detail marketplace-profile-image">
              <div className="single-market-place-img ">
                <Skeleton height={51} width={51} circle={true} />
              </div>
              <div className="ms-3 top-left-sect-detail-content">
                <div className="title-rating">
                  <h5>
                    <Skeleton height={30} width={230} />
                  </h5>
                  <div className="rating-main">
                    <Skeleton height={20} width={20} />
                    <p>
                      <Skeleton height={20} width={35} />
                    </p>
                  </div>
                </div>
                <p>
                  <Skeleton height={20} width={330} />
                  <Skeleton height={20} width={330} />
                </p>
              </div>
            </div>
            <div className="top-section-right">
              <h5>
                <Skeleton height={25} width={150} />
              </h5>
              <Skeleton height={35} width={150} />
            </div>
          </div>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "MARKETMAINLEFT") {
    return (
      <>
        <div className="all-marketplace-main-content">
          <div className="parentstickey">
            <div className="tabin-title tabborder">
              <div className="machine-detail-tab-box">
                <div class="tabing-custom position-absolute top-0">
                  <Skeleton height={20} width={120} />
                </div>
                <ul className="mb-3 custom-tabing nav nav-tabs nav-fill">
                  <li className="nav-item mx-2">
                    <Skeleton height={20} width={400} />
                  </li>
                </ul>
              </div>
              <div className="machine-detail-left-grid">
                <div className="machine-detail-left-sidebar">
                  <h2 className="mb-2">
                    <Skeleton height={28} width={"100%"} />
                  </h2>
                  <div className="all-informations-main">
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-content"
                  style={{ height: "100% !important" }}
                >
                  <div className="all-report-images">
                    <Skeleton height={250} width={"100%"} />
                    <div className="smaller-size-images">
                      <Skeleton height={8} width={8} round />
                      <Skeleton height={8} width={8} round />
                    </div>
                  </div>
                  <div className="key-benifits-main">
                    <h4>
                      <Skeleton height={28} width={200} />
                    </h4>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </div>
                  <div className="key-benifits-main">
                    <h4>
                      <Skeleton height={28} width={200} />
                    </h4>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </div>
                  <div className="key-benifits-main">
                    <h4>
                      <Skeleton height={28} width={200} />
                    </h4>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </div>
                  <div className="similar-items">
                    <h3>
                      <Skeleton height={28} width={100} />
                    </h3>
                    <div className="all-market-place-main view-similar-market-place-main">
                      <div className="single-market-place-main">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="single-market-place-img">
                            <Skeleton height={34} width={34} circle={true} />
                          </div>
                          <h3 className="report-price-single">
                            <Skeleton height={30} width={80} />
                          </h3>
                        </div>
                        <div className="market-place-content">
                          <div className="market-place-content-title">
                            <h4>
                              <Skeleton height={20} width={100} />
                            </h4>
                            <div className="market-place-content-ratings">
                              <span>
                                <Skeleton height={10} width={30} />
                              </span>
                            </div>
                          </div>
                          <p>
                            <Skeleton height={20} width={"100%"} />
                            <Skeleton height={20} width={"100%"} />
                            <Skeleton height={20} width={"100%"} />
                          </p>
                          <div className="d-flex align-items-end justify-content-between">
                            <div className="developer-name">
                              <Skeleton height={15} width={55} />
                              <Skeleton height={20} width={100} />
                            </div>
                            <Link className="crossarrow ms-auto">
                              <Skeleton height={34} width={34} circle={true} />
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="single-market-place-main">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="single-market-place-img">
                            <Skeleton height={34} width={34} circle={true} />
                          </div>
                          <h3 className="report-price-single">
                            <Skeleton height={30} width={80} />
                          </h3>
                        </div>
                        <div className="market-place-content">
                          <div className="market-place-content-title">
                            <h4>
                              <Skeleton height={20} width={100} />
                            </h4>
                            <div className="market-place-content-ratings">
                              <span>
                                <Skeleton height={10} width={30} />
                              </span>
                            </div>
                          </div>
                          <p>
                            <Skeleton height={20} width={"100%"} />
                            <Skeleton height={20} width={"100%"} />
                            <Skeleton height={20} width={"100%"} />
                          </p>
                          <div className="d-flex align-items-end justify-content-between">
                            <div className="developer-name">
                              <Skeleton height={15} width={55} />
                              <Skeleton height={20} width={100} />
                            </div>
                            <Link className="crossarrow ms-auto">
                              <Skeleton height={34} width={34} circle={true} />
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="single-market-place-main">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="single-market-place-img">
                            <Skeleton height={34} width={34} circle={true} />
                          </div>
                          <h3 className="report-price-single">
                            <Skeleton height={30} width={80} />
                          </h3>
                        </div>
                        <div className="market-place-content">
                          <div className="market-place-content-title">
                            <h4>
                              <Skeleton height={20} width={100} />
                            </h4>
                            <div className="market-place-content-ratings">
                              <span>
                                <Skeleton height={10} width={30} />
                              </span>
                            </div>
                          </div>
                          <p>
                            <Skeleton height={20} width={"100%"} />
                            <Skeleton height={20} width={"100%"} />
                            <Skeleton height={20} width={"100%"} />
                          </p>
                          <div className="d-flex align-items-end justify-content-between">
                            <div className="developer-name">
                              <Skeleton height={15} width={55} />
                              <Skeleton height={20} width={100} />
                            </div>
                            <Link className="crossarrow ms-auto">
                              <Skeleton height={34} width={34} circle={true} />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (type.toUpperCase() === "MARKETMAINRIGHT") {
    return (
      <>
        <Col>
          <div className="information-main bg-white p-3">
            <h2 className="mb-2">
              {" "}
              <Skeleton height={28} width={"100%"} />
            </h2>
            <div className="all-informations-main">
              <div className="single-informations-main">
                <h5>
                  <Skeleton height={20} width={150} />
                </h5>
                <Skeleton height={20} width={"100%"} />
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
              <div className="single-informations-main">
                <h5>
                  <Skeleton height={20} width={150} />
                </h5>
                <Skeleton height={20} width={"100%"} />
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
              <div className="single-informations-main">
                <h5>
                  <Skeleton height={20} width={150} />
                </h5>
                <Skeleton height={20} width={"100%"} />
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
              <div className="single-informations-main">
                <h5>
                  <Skeleton height={20} width={150} />
                </h5>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
              <div className="single-informations-main">
                <h5>
                  <Skeleton height={20} width={150} />
                </h5>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
              <div className="single-informations-main">
                <h5>
                  <Skeleton height={20} width={150} />
                </h5>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
                <p>
                  <Skeleton height={20} width={"100%"} />
                </p>
              </div>
            </div>
          </div>
        </Col>
      </>
    );
  } else if (type.toUpperCase() === "PROJECTCARD") {
    return (
      <>
        {line.map((item, index) => (
          <div key={index} className="position-relative">
            <div className="SingleProjectCard-main common-white-bg">
              <div className="status-and-actions">
                <div className="status-active">
                  <Skeleton width={60} />
                </div>
                <div className="all-actions">
                  <Skeleton circle={true} height={24} width={24} />
                  <Skeleton circle={true} height={24} width={24} />
                  <Skeleton circle={true} height={24} width={24} />
                  <Skeleton circle={true} height={24} width={24} />
                </div>
              </div>
              <div className="project-title-detail">
                <Skeleton height={20} width={130} />
              </div>
              <div className="d-flex align-items-center justify-content-between property-and-ticks">
                <div className="d-flex align-items-center gap-1">
                  <Skeleton height={12} width={24} />
                </div>
                <div className="d-flex algn-items-center gap-2 succeed-failed">
                  <div className="d-flex align-items-center gap-1">
                    <Skeleton height={12} width={35} />
                  </div>
                  <div className="d-flex align-items-center gap-1">
                    <Skeleton height={12} width={35} />
                  </div>
                </div>
              </div>
              <div className="all-project-feature">
                <div className="single-project-feature flex-row">
                  <Skeleton height={20} width={20} />
                  <Skeleton height={20} width={20} />
                </div>
                <div className="single-project-feature flex-row">
                  <Skeleton height={20} width={20} />
                  <Skeleton height={20} width={20} />
                </div>
                <div className="single-project-feature flex-row">
                  <Skeleton height={20} width={20} />
                  <Skeleton height={20} width={20} />
                </div>
                <div className="single-project-feature flex-row">
                  <Skeleton height={20} width={20} />
                  <Skeleton height={20} width={20} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "REVIEWDETAILHEADING") {
    return (
      <div className="d-flex align-items-center justify-content-between w-100 mb40">
        <div className="top-left-sect-detail">
          <div className="top-left-sect-detail-img">
            <Skeleton height={60} width={60} circle={true} />
          </div>
          <div className="top-left-sect-detail-content">
            <div className="title-rating">
              <h5>
                <Skeleton height={30} width={230} />
              </h5>
              <div className="rating-main">
                <Skeleton height={20} width={20} />
                <p>
                  <Skeleton height={20} width={35} />
                </p>
              </div>
            </div>
            <p>
              <Skeleton height={20} width={330} />
              <Skeleton height={20} width={330} />
            </p>
          </div>
        </div>
        <div className="top-section-right">
          <h5>
            <Skeleton height={20} width={150} />
          </h5>
        </div>
      </div>
    );
  } else if (type.toUpperCase() === "REVIEWDETAILLEFT") {
    return (
      <div className="all-report-images">
        <Skeleton height={250} width={"100%"} />
        <div className="smaller-size-images">
          <Skeleton height={58} width={58} />
          <Skeleton height={58} width={58} />
        </div>
      </div>
    );
  } else if (type.toUpperCase() === "REVIEWDETAILRIGHT") {
    return (
      <div className="information-main general-informatio-main">
        <div className="general-informatio-main-inner-wrapper">
          <h2 className="mb12">
            <Skeleton height={20} width={100} />
          </h2>
          <div className="all-general-informations-main">
            <div className="d-flex align-items-center justify-content-between">
              <p>
                <Skeleton height={20} width={300} />
              </p>
              <p>
                <Skeleton height={20} width={100} />
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p>
                <Skeleton height={20} width={300} />
              </p>
              <p>
                <Skeleton height={20} width={100} />
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p>
                <Skeleton height={20} width={300} />
              </p>
              <p>
                <Skeleton height={20} width={100} />
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p>
                <Skeleton height={20} width={300} />
              </p>
              <p>
                <Skeleton height={20} width={100} />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (type.toUpperCase() === "COMPLETEPROFILE") {
    return (
      <div className="main-page-content profilecomplate-common profilecom">
        <Container className="profile-complition-container">
          <div className="complete-profile-main-content mt-5">
            <div className="select-profile-type">
              <h6>
                {location?.pathname?.includes("management-listing") ? (
                  <div style={{ height: "20px" }}></div>
                ) : (
                  <Skeleton height={20} width={150} />
                )}
              </h6>
              <div className="d-flex align-items-center gap-3">
                {location?.pathname?.includes("management-listing") ? (
                  <></>
                ) : (
                  <>
                    <Skeleton height={20} width={125} />
                    <Skeleton height={20} width={125} />
                  </>
                )}
                {/*  */}
              </div>
            </div>
            <div className="main-section-for-profile-completion">
              {line.map((item, index) => (
                <div
                  key={index}
                  className="single-section-for-profile-completion"
                >
                  <div className="single-section-for-profile-completion-left">
                    <h3>
                      <Skeleton height={20} width={170} />
                    </h3>
                    <p>
                      <Skeleton height={20} width={420} />
                      <Skeleton height={20} width={420} />
                      <Skeleton height={20} width={170} />
                    </p>
                  </div>
                  <div className="single-section-for-profile-completion-right">
                    <div className="d-flex gap-2">
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          <Skeleton height={17} width={70} />
                        </Form.Label>
                        <div className="position-relative">
                          <Skeleton height={32} width={"100%"} />
                        </div>
                      </Form.Group>
                      <Form.Group className="form-group mb12  w-100">
                        <Form.Label className="common-label">
                          <Skeleton height={17} width={70} />
                        </Form.Label>
                        <div className="position-relative">
                          <Skeleton height={32} width={"100%"} />
                        </div>
                      </Form.Group>
                    </div>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <Skeleton height={32} width={"100%"} />
                    </Form.Group>
                    <Form.Group className="form-group mb12">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <div className="position-relative">
                        <Skeleton height={32} width={"100%"} />
                      </div>
                    </Form.Group>
                    <div className="d-flex gap-2">
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          <Skeleton height={17} width={70} />
                        </Form.Label>
                        <Skeleton height={32} width={"100%"} />
                      </Form.Group>
                      <Form.Group className="form-group mb12 w-100">
                        <Form.Label className="common-label">
                          <Skeleton height={17} width={70} />
                        </Form.Label>
                        <Skeleton height={32} width={"100%"} />
                      </Form.Group>
                    </div>
                    <Form.Group className="form-group">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <Skeleton height={32} width={"100%"} />
                    </Form.Group>
                  </div>
                </div>
              ))}
              {/* <div className="single-section-for-profile-completion">
                <div className="single-section-for-profile-completion-left">
                  <h3>
                    <Skeleton height={20} width={170} />
                  </h3>
                  <p>
                    <Skeleton height={20} width={420} />
                    <Skeleton height={20} width={420} />
                    <Skeleton height={20} width={170} />
                  </p>
                </div>
                <div className="single-section-for-profile-completion-right">
                  <Form.Group className="form-group mb12">
                    <Form.Label className="common-label">
                      <Skeleton height={17} width={70} />
                    </Form.Label>
                    <Skeleton height={32} width={"100%"} />
                  </Form.Group>
                  <Form.Group className="form-group mb12">
                    <Form.Label className="common-label">
                      <Skeleton height={17} width={70} />
                    </Form.Label>
                    <Skeleton height={32} width={"100%"} />
                  </Form.Group>
                  <div className="d-flex gap-2">
                    <Form.Group className="form-group mb12 w-100">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <Skeleton height={32} width={"100%"} />
                    </Form.Group>
                    <Form.Group className="form-group mb12 w-100">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <Skeleton height={32} width={"100%"} />
                    </Form.Group>
                  </div>
                  <div className="d-flex gap-2">
                    <Form.Group className="form-group w-100">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <Skeleton height={32} width={"100%"} />
                    </Form.Group>
                    <Form.Group className="form-group w-100">
                      <Form.Label className="common-label">
                        <Skeleton height={17} width={70} />
                      </Form.Label>
                      <Skeleton height={32} width={"100%"} />
                    </Form.Group>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </Container>
      </div>
    );
  } else if (type.toUpperCase() === "NUMBERCOUNT") {
    return (
      <>
        {line.map((item, index) => (
          <div
            key={index}
            className="my-machine-top-box-single common-machines"
          >
            <h4>
              <Skeleton height={24} width={24} />
            </h4>
            <p>
              <Skeleton height={20} width={"100%"} />
            </p>
          </div>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "TABLEROW") {
    return (
      <>
        {line.map((item, index) => (
          <tr key={index}>
            {td.map((tditem, tdindex) => (
              <td>
                <Skeleton height={lineheight} />
              </td>
            ))}
          </tr>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "FILECONTENT") {
    return (
      <>
        {line.map((item, index) => (
          <div>
            <Skeleton height={20} />
          </div>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "FILES") {
    return (
      <>
        {line.map((item, index) => (
          <div className="code-folder-structure-single-folder">
            <div className="cursor-pointer d-flex align-items-center gap-2">
              <Skeleton height={20} />
            </div>
          </div>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "DEVELOPERHEADER") {
    return (
      <>
        {line.map((item, index) => (
          <div
            key={index}
            className="d-flex align-items-center justify-content-between w-100 mb40"
          >
            <div className="top-left-sect-detail marketplace-profile-image">
              <div className="single-market-place-img ">
                <Skeleton height={51} width={51} circle={true} />
              </div>
              <div className="ms-3 top-left-sect-detail-content">
                <div className="title-rating">
                  {/* <h5>
                    <Skeleton height={30} width={230} />
                  </h5> */}
                  {/* <div className="rating-main">
                    <Skeleton height={20} width={20} />
                    <p>
                      <Skeleton height={20} width={35} />
                    </p>
                  </div> */}
                </div>
                <p>
                  <Skeleton height={20} width={330} />
                  <Skeleton height={20} width={330} />
                </p>
              </div>
            </div>
            <div className="top-section-right">
              <h5>
                <Skeleton height={25} width={150} />
              </h5>
              <Skeleton height={35} width={150} />
            </div>
          </div>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "DEVELOPERMAIN") {
    return (
      <>
        <Row>
          <div className="tabin-title tabborder position-relative">
            <div class="tabing-custom position-absolute top-0">
              <Skeleton height={20} width={120} />
            </div>
            <ul className="mb-3 custom-tabing nav nav-tabs nav-fill">
              <li className="nav-item mx-2">
                <Skeleton height={20} width={400} />
              </li>
            </ul>
            <div className="d-flex gap-2">
              <Col lg={9} xl={9}>
                <div className="tab-content">
                  <div className="all-report-images">
                    <Skeleton height={250} width={"100%"} />
                    <div className="smaller-size-images">
                      <Skeleton height={58} width={58} />
                      <Skeleton height={58} width={58} />
                    </div>
                  </div>
                  <div className="key-benifits-main">
                    <h4>
                      <Skeleton height={28} width={200} />
                    </h4>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </div>
                  <div className="key-benifits-main">
                    <h4>
                      <Skeleton height={28} width={200} />
                    </h4>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </div>
                  <div className="key-benifits-main">
                    <h4>
                      <Skeleton height={28} width={200} />
                    </h4>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </div>
                  <div className="all-reviews-main mt-3">
                    {/* <h6>
              <Skeleton height={28} width={100} />
            </h6> */}
                    {/* <div className="all-reviews-top">
              <div className="all-reviews-top-single">
                <h4>
                  <Skeleton height={20} width={100} />
                </h4>
                <h3>
                  <Skeleton height={30} width={30} />
                </h3>
              </div>
              <div className="all-reviews-top-single">
                <h4>
                  <Skeleton height={20} width={100} />
                </h4>
                <h3>
                  <Skeleton height={30} width={30} />
                </h3>
              </div>
              <div className="all-reviews-top-single">
                <h4>
                  <Skeleton height={20} width={100} />
                </h4>
                <h3>
                  <Skeleton height={30} width={30} />
                </h3>
              </div>
              <div className="all-reviews-top-single">
                <h4>
                  <Skeleton height={20} width={100} />
                </h4>
                <h3>
                  <Skeleton height={30} width={30} />
                </h3>
              </div>
            </div> */}
                    {/* <div className="all-written-review">
              <div className="single-written-review">
                <div className="single-written-review-left">
                  <Skeleton height={80} width={80} />
                  <div>
                    <h5>
                      <Skeleton height={20} width={80} />
                    </h5>
                    <p>
                      <Skeleton height={20} width={60} />
                    </p>
                    <Skeleton height={20} width={70} />
                  </div>
                </div>
                <div className="single-written-review-right">
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                </div>
              </div>
              <div className="single-written-review">
                <div className="single-written-review-left">
                  <Skeleton height={80} width={80} />
                  <div>
                    <h5>
                      <Skeleton height={20} width={80} />
                    </h5>
                    <p>
                      <Skeleton height={20} width={60} />
                    </p>
                    <Skeleton height={20} width={70} />
                  </div>
                </div>
                <div className="single-written-review-right">
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                </div>
              </div>
              <div className="single-written-review">
                <div className="single-written-review-left">
                  <Skeleton height={80} width={80} />
                  <div>
                    <h5>
                      <Skeleton height={20} width={80} />
                    </h5>
                    <p>
                      <Skeleton height={20} width={60} />
                    </p>
                    <Skeleton height={20} width={70} />
                  </div>
                </div>
                <div className="single-written-review-right">
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                  <p>
                    <Skeleton height={20} width={700} />
                  </p>
                </div>
              </div>
            </div> */}
                  </div>
                </div>
              </Col>
              <Col lg={3} xl={3}>
                <div className="information-main mt-4">
                  <h2 className="mb-2">
                    {" "}
                    <Skeleton height={28} width={"100%"} />
                  </h2>
                  <div className="all-informations-main">
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                    <div className="single-informations-main">
                      <h5>
                        <Skeleton height={20} width={150} />
                      </h5>
                      <Skeleton height={20} width={"100%"} />
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                      <p>
                        <Skeleton height={20} width={"100%"} />
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </div>
          <div className="similar-items">
            <h3>
              <Skeleton height={28} width={100} />
            </h3>
            <div className="all-market-place-main view-similar-market-place-main">
              <div className="single-market-place-main">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="single-market-place-img">
                    <Skeleton height={34} width={34} circle={true} />
                  </div>
                  <h3 className="report-price-single">
                    <Skeleton height={30} width={80} />
                  </h3>
                </div>
                <div className="market-place-content">
                  <div className="market-place-content-title">
                    <h4>
                      <Skeleton height={20} width={100} />
                    </h4>
                    <div className="market-place-content-ratings">
                      <span>
                        <Skeleton height={10} width={30} />
                      </span>
                    </div>
                  </div>
                  <p>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </p>
                  <div className="d-flex align-items-end justify-content-between">
                    <div className="developer-name">
                      <Skeleton height={15} width={55} />
                      <Skeleton height={20} width={100} />
                    </div>
                    <Link className="crossarrow ms-auto">
                      <Skeleton height={34} width={34} circle={true} />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="single-market-place-main">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="single-market-place-img">
                    <Skeleton height={34} width={34} circle={true} />
                  </div>
                  <h3 className="report-price-single">
                    <Skeleton height={30} width={80} />
                  </h3>
                </div>
                <div className="market-place-content">
                  <div className="market-place-content-title">
                    <h4>
                      <Skeleton height={20} width={100} />
                    </h4>
                    <div className="market-place-content-ratings">
                      <span>
                        <Skeleton height={10} width={30} />
                      </span>
                    </div>
                  </div>
                  <p>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </p>
                  <div className="d-flex align-items-end justify-content-between">
                    <div className="developer-name">
                      <Skeleton height={15} width={55} />
                      <Skeleton height={20} width={100} />
                    </div>
                    <Link className="crossarrow ms-auto">
                      <Skeleton height={34} width={34} circle={true} />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="single-market-place-main">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="single-market-place-img">
                    <Skeleton height={34} width={34} circle={true} />
                  </div>
                  <h3 className="report-price-single">
                    <Skeleton height={30} width={80} />
                  </h3>
                </div>
                <div className="market-place-content">
                  <div className="market-place-content-title">
                    <h4>
                      <Skeleton height={20} width={100} />
                    </h4>
                    <div className="market-place-content-ratings">
                      <span>
                        <Skeleton height={10} width={30} />
                      </span>
                    </div>
                  </div>
                  <p>
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                    <Skeleton height={20} width={"100%"} />
                  </p>
                  <div className="d-flex align-items-end justify-content-between">
                    <div className="developer-name">
                      <Skeleton height={15} width={55} />
                      <Skeleton height={20} width={100} />
                    </div>
                    <Link className="crossarrow ms-auto">
                      <Skeleton height={34} width={34} circle={true} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </>
    );
  } else if (type.toUpperCase() === "WORKFLOWCONTACTS") {
    return (
      <>
        {line.map((item, index) => (
          <Row key={index}>
            <Col>
              <div className="d-flex align-items-center justify-content-between contact-detail-in-flow-page-inner">
                <div className="contact-detail-in-flow-page">
                  <div className="contact-detail-in-flow-page-img">
                    <img src={profileicon} alt={"Contact 1"} />
                  </div>
                  <div className="contact-detail-in-flow-page-detail">
                    <Skeleton height={15} width={200} />
                    <Skeleton height={13} width={150} />
                  </div>
                </div>
                <div className="all-report-images">
                  <div className="mt-2">
                    <Skeleton height={30} width={48} />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "CASEDETAILWORKFLOWCONTACTS") {
    return (
      <>
        {line.map((item, index) => (
          <Row key={index}>
            <Col>
              <div className="d-flex align-items-center justify-content-between contact-detail-in-flow-page-inner">
                <div className="contact-detail-in-flow-page">
                  <div className="contact-detail-in-flow-page-img">
                    <img src={profileicon} alt={"Contact 1"} />
                  </div>
                  <div className="contact-detail-in-flow-page-detail">
                    <Skeleton height={15} width={130} />
                    <Skeleton height={13} width={50} />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "SOURCECODE") {
    return (
      <>
        <div className="source-code-main">
          <div className="source-code-left">
            {line.map((item, index) => (
              <Skeleton height={25} width={230} />
            ))}
          </div>
          <div className="source-code-left source-code-right w-100">
            {line.map((item, index) => (
              <Skeleton height={25} width={"100%"} />
            ))}
          </div>
        </div>
      </>
    );
  } else if (type.toUpperCase() === "AIGENERATEMODAL") {
    return (
      <>
        <Row>
          {line.map((item, index) => (
            <Col key={index} xs={6} md={4} lg={3} className="mb-3">
              <Skeleton height={100} width={"100%"} />
            </Col>
          ))}
        </Row>
      </>
    );
  } else if (type.toUpperCase() === "SUPPORTDETAIL") {
    return (
      <div className="casedetail-profile-main">
        <div className="profile-common-title">
          <h3>
            Case Detail
            {/* <Skeleton height={25} width={230} /> */}
          </h3>
        </div>
        <div className="profile-common">
          <div className="casedetail-profile">
            <div className="casedetail-profile-title">
              <div className="casedetail-profile-title-left ">
                <h3>
                  <Skeleton height={25} width={230} />
                </h3>
                <p>
                  <Skeleton height={15} width={150} />
                </p>
              </div>
              <div className="casedetail-profile-title-right d-flex align-items-center gap-2">
                <span className=" casebtnsetred">
                  <Skeleton height={25} width={100} />
                </span>
                <span className=" casebtnsetblack">
                  <Skeleton height={25} width={150} />
                </span>
                <span className=" casebtnsetblue d-flex">
                  <Skeleton height={25} width={25} />
                  <Skeleton height={25} width={200} />
                </span>
              </div>
            </div>
            <Row>
              <Col sm={3}>
                <div className="casedetail-set">
                  <h4>
                    <Skeleton height={25} width={230} />
                  </h4>
                  <p>
                    <Skeleton height={25} width={230} />
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div className="casedetail-set">
                  <h4>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </h4>
                  <p>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div className="casedetail-set">
                  <h4>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </h4>
                  <p>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div className="casedetail-set">
                  <h4>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </h4>
                  <p>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div className="casedetail-set">
                  <h4>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </h4>
                  <p>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </p>
                </div>
              </Col>
              <Col sm={3}>
                <div className="casedetail-set">
                  <h4>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </h4>
                  <p>
                    {" "}
                    <Skeleton height={25} width={230} />
                  </p>
                </div>
              </Col>
            </Row>
            <div className="case-description">
              <div className="description-title-main">
                <div className="d-flex gap-2 align-items-center">
                  <h4>
                    <Skeleton height={20} width={200} />
                  </h4>
                  <p>
                    <Skeleton height={15} width={850} />
                  </p>
                </div>
              </div>

              <div className="caseiamge-tab">
                <Tab.Container id="left-tabs-example" defaultActiveKey="">
                  <Row>
                    <Col sm={1}>
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link eventKey="first">
                            <Skeleton height={50} width={50} />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">
                            <Skeleton height={50} width={50} />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">
                            <Skeleton height={50} width={50} />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="four">
                            <Skeleton height={50} width={50} />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="five">
                            <Skeleton height={50} width={50} />
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={11}>
                      <Tab.Content>
                        <Tab.Pane eventKey="">
                          <Skeleton height={300} width={960} />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (type.toUpperCase() === "SUPPORTFILTERS") {
    return (
      <span className="d-flex gap-3">
        {line.map((item, index) => (
          <Skeleton height={25} width={110} />
        ))}
      </span>
    );
  } else if (type.toUpperCase() === "SUPPORTSETTING") {
    return line?.map((item, index) => {
      return (
        <>
          <div key={index} className="profile-common d-flex gap-5">
            <div className="mt-3 ms-2">
              <Skeleton height={40} width={40} />
            </div>
            <div className="mt-2">
              <Skeleton height={25} width={150} />
              <Skeleton height={25} width={70} />
            </div>
            <div style={{ height: "30px", width: "100px" }}></div>
            <div>
              <Skeleton height={20} width={150} />
              <Skeleton height={20} width={250} />
              <Skeleton height={20} width={150} />
            </div>
            <div className="mt-2">
              <Skeleton height={40} width={40} />
            </div>
            <div className="mt-2">
              <Skeleton height={25} width={150} />
              <Skeleton height={25} width={70} />
            </div>
            <div className="mt-2">
              <Skeleton height={40} width={40} />
            </div>
          </div>
          {/* <div className="profile-common d-flex gap-5">
              <div className="mt-3 ms-2">
                <Skeleton height={40} width={40} />
              </div>
              <div className="mt-2">
                <Skeleton height={25} width={150} />
                <Skeleton height={25} width={70} />
              </div>
              <div style={{ height: "30px", width: "100px" }}></div>
              <div>
                <Skeleton height={20} width={150} />
                <Skeleton height={20} width={250} />
                <Skeleton height={20} width={150} />
              </div>
              <div className="mt-2">
                <Skeleton height={40} width={40} />
              </div>
              <div className="mt-2">
                <Skeleton height={25} width={150} />
                <Skeleton height={25} width={70} />
              </div>
              <div className="mt-2">
                <Skeleton height={40} width={40} />
              </div>
            </div>
            <div className="profile-common d-flex gap-5">
              <div className="mt-3 ms-2">
                <Skeleton height={40} width={40} />
              </div>
              <div className="mt-2">
                <Skeleton height={25} width={150} />
                <Skeleton height={25} width={70} />
              </div>
              <div style={{ height: "30px", width: "100px" }}></div>
              <div>
                <Skeleton height={20} width={150} />
                <Skeleton height={20} width={250} />
                <Skeleton height={20} width={150} />
              </div>
              <div className="mt-2">
                <Skeleton height={40} width={40} />
              </div>
              <div className="mt-2">
                <Skeleton height={25} width={150} />
                <Skeleton height={25} width={70} />
              </div>
              <div className="mt-2">
                <Skeleton height={40} width={40} />
              </div>
            </div>
            <div className="profile-common d-flex gap-5">
              <div className="mt-3 ms-2">
                <Skeleton height={40} width={40} />
              </div>
              <div className="mt-2">
                <Skeleton height={25} width={150} />
                <Skeleton height={25} width={70} />
              </div>
              <div style={{ height: "30px", width: "100px" }}></div>
              <div>
                <Skeleton height={20} width={150} />
                <Skeleton height={20} width={250} />
                <Skeleton height={20} width={150} />
              </div>
              <div className="mt-2">
                <Skeleton height={40} width={40} />
              </div>
              <div className="mt-2">
                <Skeleton height={25} width={150} />
                <Skeleton height={25} width={70} />
              </div>
              <div className="mt-2">
                <Skeleton height={40} width={40} />
              </div>
            </div> */}
        </>
      );
    });
  } else if (type.toUpperCase() === "NOTIFICATIONLIST") {
    return line?.map((item, index) => {
      return (
        <div
          key={`${index}-notiList`}
          className="single-notification gray-notification"
        >
          <div className="single-notification-left">
            <Skeleton height={15} width={170} />
            <Skeleton height={15} width={110} />
          </div>
          <div className="single-notification-right">
            <Skeleton height={15} width={100} />
            <Skeleton height={15} width={100} />
          </div>
          {/* <div className="unread-notification"></div> */}
        </div>
      );
    });
  } else if (type.toUpperCase() === "NOTIFICATIONSETTING") {
    return line?.map((item, index) => {
      return (
        <>
          <div className="profile-common-title" key={index}>
            <Skeleton height={20} width={200} />
          </div>
          <div className="profile-common mt-1">
            <div className="checkbox-list-in-modal">
              <div>
                <Skeleton height={10} width={250} />
                <Skeleton height={10} width={350} />
                <Skeleton height={10} width={250} />
                <Skeleton height={10} width={350} />
                <Skeleton height={10} width={250} />
                <Skeleton height={10} width={350} />
              </div>
            </div>
          </div>
        </>
      );
    });
  } else if (type.toUpperCase() === "ALLMACHINEWIDGET") {
    return (
      <>
        <div className="all-services-wrapper">
          {line.map((item, index) => (
            <div
              key={index}
              className="d-flex align-items-center justify-content-between w-100 mb40"
            >
              <div className="top-left-sect-detail marketplace-profile-image">
                <div className="single-market-place-img ">
                  <Skeleton height={51} width={51} circle={true} />
                </div>
                <div className="ms-3 top-left-sect-detail-content">
                  <div className="title-rating"></div>
                  <p>
                    <Skeleton height={20} width={280} />
                    <Skeleton height={20} width={280} />
                    <Skeleton height={20} width={280} />
                    <Skeleton height={20} width={280} />
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  } else if (type.toUpperCase() === "ALLANNOUNCEMENTS") {
    return (
      <>
        <div className="single-announcement-item h-100">
          <div className="date-box common-white-bg">
            <span>
              <Skeleton height={20} width={70} />
              <span className="d-flex gap-2 align-items-center">
                <Skeleton height={10} width={30} />
                <Skeleton height={10} width={30} />
              </span>
            </span>
          </div>
          <div className="single-announcement cursor-pointer common-white-bg flex-grow-1">
            <h3>
              <Skeleton height={18} width={100} />
            </h3>
            <p>
              <Skeleton height={10} width={100} />
              <Skeleton height={10} width={50} />
            </p>
          </div>
        </div>
      </>
    );
  } else if (type.toUpperCase() === "DASHBLOCKDATA") {
    return (
      <>       
        <div className="costing-sec dashblockdata">
          <div
            className="all-costing-box"
            style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: "10px" }}
          >
            {line.map((item, index) => (
              <div key={index} className="single-costing-box common-white-bg d-flex flex-column justify-content-between align-items-center text-center" style={{ minHeight: "104px", padding: "10px 8px", minWidth: 0 }}>
                <div>
                  <h5>
                    <Skeleton height={20} width={30} />
                  </h5>
                  <p>
                    <Skeleton height={15} width={50} />
                  </p>
                </div>                
                  <Skeleton height={40} width={40} circle={true} />               
              </div>
            ))}
          </div>
        </div>
      </>
    );
  } else if (type.toUpperCase() === "COSTWIDGET") {
    return (
      <>
        <div className="all-costing-box">
          {line.map((item, index) => (
            <div
              key={index}
              className="single-costing-box common-white-bg mw-100"
            >
              <h5>
                $ <Skeleton height={25} width={100} />
              </h5>
              <p>
                <Skeleton height={15} width={125} />
                <Skeleton height={15} width={80} />
              </p>
            </div>
          ))}
        </div>
        <div className="gray-warning-sec">
          <p>
            <Skeleton height={20} width={210} />
          </p>
        </div>
      </>
    );
  } else if (type.toUpperCase() === "PRICETYPE") {
    <p>
      <Skeleton height={20} width={"100%"} />
      <Skeleton height={20} width={"100%"} />
      <Skeleton height={20} width={"100%"} />
    </p>;
  } else if (type.toUpperCase() === "CHARTLINE") {
    return (
      <>
        <p>
          <div className="d-flex gap-3 align-items-end">
            <div>
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
            </div>
            <Skeleton height={225} width={2} />
            <div className="chart-bars-load d-flex gap-5 align-items-end">
              <Skeleton height={20} width={50} />
              <Skeleton height={70} width={50} />
              <Skeleton height={30} width={50} />
              <Skeleton height={120} width={50} />
              <Skeleton height={180} width={50} />
              <Skeleton height={80} width={50} />
              <Skeleton height={30} width={50} />
              <Skeleton height={120} width={50} />
              <Skeleton height={150} width={50} />
              <Skeleton height={20} width={50} />
              <Skeleton height={70} width={50} />
              <Skeleton height={30} width={50} />
            </div>
          </div>
          <Skeleton height={2} width={"100%"} />
        </p>
      </>
    );
  } else if (type.toUpperCase() === "DAILYACTIVITYCHARTLINE") {
    return (
      <>
        <p>
          <div className="d-flex gap-3 align-items-end activity-chart">
            <div>
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
            </div>
            <Skeleton height={225} width={2} />
            <div className="chart-bars-load d-flex gap-3 align-items-end">
              <Skeleton height={20} width={20} />
              <Skeleton height={70} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={120} width={20} />
              <Skeleton height={180} width={20} />
              <Skeleton height={80} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={120} width={20} />
              <Skeleton height={150} width={20} />
              <Skeleton height={20} width={20} />
              <Skeleton height={70} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={180} width={20} />
              <Skeleton height={80} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={120} width={20} />
              <Skeleton height={150} width={20} />
              <Skeleton height={20} width={20} />
              <Skeleton height={70} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={180} width={20} />
              <Skeleton height={80} width={20} />
              <Skeleton height={30} width={20} />
              <Skeleton height={120} width={20} />
              <Skeleton height={150} width={20} />
            </div>
          </div>
          <Skeleton height={2} width={"100%"} />
        </p>
      </>
    );
  } else if (type.toUpperCase() === "AIENHANCEDMACHINE") {
    return (
      <>
        <div style={{ width: "161px" }} className="machine-with-image-single">
          <h5>
            <Skeleton height={16} width={90} />
          </h5>
          <span>
            <Skeleton height={27} width={27} />
          </span>
        </div>
        <p style={{ width: "500px" }}>
          <Skeleton height={10} width={"100%"} />
          <Skeleton height={10} width={"100%"} />
          <Skeleton height={10} width={"50px"} />
        </p>
        <span>
          <Skeleton height={"36px"} width={"104px"} />
        </span>
      </>
    );
  } else if (type.toUpperCase() === "CHARTTHINLINE") {
    return (
      <>
        <p>
          <div className="d-flex gap-3 align-items-end">
            <div>
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
              <Skeleton height={8} width={17} />
            </div>
            <Skeleton height={170} width={2} />
            <div className="chart-thin-bars-load d-flex align-items-end">
              <Skeleton height={20} width={10} />
              <Skeleton height={90} width={10} />
              <Skeleton height={50} width={10} />
              <Skeleton height={170} width={10} />
              <Skeleton height={120} width={10} />
            </div>
          </div>
          <Skeleton height={2} width={"100%"} />
        </p>
      </>
    );
  } else if (type.toUpperCase() === "PAYMENTMETHODCARD") {
    return (
      <>
        {line.map((item, index) => (
          <Col xl={6}>
            <div className="main-payment-method">
              <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                <div className="payment-method-detail d-block">
                  <div>
                    <Skeleton height={40} width={100} />
                  </div>
                  <div className="d-flex">
                    <div>
                      <Skeleton height={10} width={100} />
                    </div>
                    <div className="ms-2">
                      <Skeleton height={10} width={100} />
                    </div>
                  </div>
                  <div>
                    <Skeleton height={10} width={100} />
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <Skeleton height={10} width={200} />
                    </div>
                    <div className="ms-2">
                      <Skeleton height={15} width={15} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "PAYMENTMETHODSINGLECARD") {
    return (
      <>
        {line.map((item, index) => (
          <Col xl={12}>
            <div className="main-payment-method">
              <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                <div className="payment-method-detail d-block">
                  <div>
                    <Skeleton height={40} width={100} />
                  </div>
                  <div className="d-flex">
                    <div>
                      <Skeleton height={10} width={100} />
                    </div>
                    <div className="ms-2">
                      <Skeleton height={10} width={100} />
                    </div>
                  </div>
                  <div>
                    <Skeleton height={10} width={100} />
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <Skeleton height={10} width={200} />
                    </div>
                    <div className="ms-2">
                      <Skeleton height={15} width={15} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "PAYMENTNEXTBILLING") {
    return (
      <>
        {line.map((item, index) => (
          <Col xl={12}>
            <div className="main-payment-method">
              <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                <div className="payment-method-detail d-block">
                  <div>
                    <Skeleton height={20} width={200} />
                  </div>
                  <div className="d-flex">
                    <div>
                      <div className="mt-3">
                        <Skeleton height={30} width={300} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </>
    );
  } else if (type.toUpperCase() === "MACHINE360HEADER") {
    return (
      <div className="m360-hero-card">
        <div className="m360-hero-left">
          <div className="m360-avatar-container">
            <div className="m360-avatar-inner" style={{ border: "none", background: "transparent" }}>
              <Skeleton circle={true} height={44} width={44} />
            </div>
          </div>
          <div className="m360-hero-info" style={{ width: "100%", maxWidth: 520 }}>
            <div className="m360-title-row" style={{ gap: 8 }}>
              <Skeleton height={28} width={260} />
              <Skeleton height={20} width={48} borderRadius={4} />
              <Skeleton height={20} width={42} borderRadius={4} />
            </div>
            <div className="m360-description my-2">
              <Skeleton height={14} width="92%" />
              <Skeleton height={14} width="70%" />
            </div>
            <div className="m360-tags-row">
              <Skeleton height={22} width={75} borderRadius={12} />
              <Skeleton height={22} width={85} borderRadius={12} />
              <Skeleton height={22} width={95} borderRadius={12} />
            </div>
          </div>
        </div>
        <div className="m360-hero-right">
          <div className="m360-actions-row">
            <Skeleton height={28} width={55} borderRadius={4} />
            <Skeleton height={32} width={70} borderRadius={4} />
            <Skeleton height={32} width={82} borderRadius={4} />
          </div>
          <div className="m360-meta-grid">
            <div className="m360-meta-item">
              <Skeleton height={11} width={70} />
              <Skeleton height={13} width={95} />
            </div>
            <div className="m360-meta-item">
              <Skeleton height={11} width={70} />
              <Skeleton height={13} width={85} />
            </div>
            <div className="m360-meta-item">
              <Skeleton height={11} width={45} />
              <Skeleton height={13} width={40} />
            </div>
          </div>
        </div>
      </div>
    );
  } else if (type.toUpperCase() === "MACHINE360SIDEBAR") {
    return (
      <aside className="m360-sidebar-card">
        <div className="m360-sidebar-header">
          <Skeleton height={20} width={130} />
          <Skeleton height={20} width={45} />
        </div>
        <div className="m360-sidebar-section">
          <Skeleton height={14} width={90} />
          <div className="m360-detail-row mt-2">
            <Skeleton height={14} width={65} />
            <Skeleton height={14} width={85} />
          </div>
        </div>
        <div className="m360-sidebar-section">
          <Skeleton height={14} width={75} />
          <div className="m360-categories-list mt-2">
            <Skeleton height={24} width={90} borderRadius={12} />
          </div>
        </div>
        <div className="m360-sidebar-section">
          <Skeleton height={14} width={95} />
          <div className="mt-2">
            <Skeleton height={14} width={45} />
          </div>
        </div>
        <div className="m360-sidebar-section">
          <Skeleton height={14} width={160} />
          <div className="m360-detail-row mt-2">
            <Skeleton height={14} width={130} />
            <Skeleton height={14} width={30} />
          </div>
          <div className="m360-detail-row">
            <Skeleton height={14} width={130} />
            <Skeleton height={14} width={30} />
          </div>
          <div className="m360-detail-row">
            <Skeleton height={14} width={55} />
            <Skeleton height={14} width={40} />
          </div>
        </div>
        <div className="m360-sidebar-section">
          <Skeleton height={14} width={75} />
          <div className="m360-data-file-item mt-2">
            <div className="m360-data-file-top">
              <Skeleton height={14} width={75} />
              <Skeleton height={24} width={75} borderRadius={4} />
            </div>
            <div className="mt-1">
              <Skeleton height={12} width="90%" />
            </div>
          </div>
          <div className="m360-data-file-item">
            <div className="m360-data-file-top">
              <Skeleton height={14} width={85} />
              <Skeleton height={24} width={75} borderRadius={4} />
            </div>
            <div className="mt-1">
              <Skeleton height={12} width="90%" />
            </div>
          </div>
        </div>
        <div className="m360-infra-card">
          <Skeleton height={16} width={160} />
          <div className="m360-infra-row mt-2">
            <Skeleton height={14} width={110} />
            <Skeleton height={14} width={45} />
          </div>
          <div className="m360-infra-row">
            <Skeleton height={14} width={45} />
            <Skeleton height={14} width={40} />
          </div>
          <div className="m360-infra-row">
            <Skeleton height={14} width={60} />
            <Skeleton height={14} width={40} />
          </div>
          <div className="m360-infra-row">
            <Skeleton height={14} width={50} />
            <Skeleton height={14} width={40} />
          </div>
        </div>
        <div className="m360-sidebar-section m360-usage-stats-section">
          <Skeleton height={14} width={85} />
          <div className="m360-detail-row mt-2">
            <Skeleton height={14} width={110} />
            <Skeleton height={14} width={30} />
          </div>
          <div className="m360-detail-row">
            <Skeleton height={14} width={120} />
            <Skeleton height={14} width={30} />
          </div>
        </div>
      </aside>
    );
  } else if (type.toUpperCase() === "MACHINE360KPI") {
    return (
      <div className="m360-kpi-grid">
        {[0, 1, 2, 3].map((idx) => (
          <div key={idx} className="m360-kpi-card">
            <div className="m360-kpi-icon-wrap" style={{ background: "transparent" }}>
              <Skeleton circle={true} height={42} width={42} />
            </div>
            <div className="m360-kpi-content" style={{ width: "100%" }}>
              <Skeleton height={12} width={75} />
              <div style={{ margin: "4px 0" }}>
                <Skeleton height={24} width={55} />
              </div>
              <Skeleton height={12} width={95} />
            </div>
          </div>
        ))}
      </div>
    );
  } else if (type.toUpperCase() === "WORKFLOWSUMMARY") {
    return (
      <dl className="workflow-summary-list">
        <div>
          <dt><Skeleton width={40} height={14} /></dt>
          <dd><Skeleton width="75%" height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={42} height={14} /></dt>
          <dd><Skeleton width={56} height={18} borderRadius={12} /></dd>
        </div>
        <div>
          <dt><Skeleton width={82} height={14} /></dt>
          <dd><Skeleton width={20} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={62} height={14} /></dt>
          <dd><Skeleton width={72} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={58} height={14} /></dt>
          <dd><Skeleton width={72} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={58} height={14} /></dt>
          <dd><Skeleton width={80} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={55} height={14} /></dt>
          <dd><Skeleton width={75} height={18} borderRadius={12} /></dd>
        </div>
        <div>
          <dt><Skeleton width={68} height={14} /></dt>
          <dd><Skeleton width={95} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={68} height={14} /></dt>
          <dd><Skeleton width={125} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={82} height={14} /></dt>
          <dd><Skeleton width={125} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={68} height={14} /></dt>
          <dd><Skeleton width={70} height={18} borderRadius={12} /></dd>
        </div>
        <div>
          <dt><Skeleton width={92} height={14} /></dt>
          <dd><Skeleton width={125} height={14} /></dd>
        </div>
        <div>
          <dt><Skeleton width={70} height={14} /></dt>
          <dd><Skeleton width={25} height={14} /></dd>
        </div>
      </dl>
    );
  } else if (type.toUpperCase() === "WORKFLOWCOSTSUMMARY") {
    return (
      <>
        <h3>Execution Cost Summary</h3>
        <div className="workflow-dashboard-table workflow-cost-table">
          <div className="workflow-dashboard-table-head">
            <span>Machines</span>
            <span>Last Run</span>
            <span>Avg. Run</span>
          </div>
          {[
            { name: 65, last: 50, avg: 50 },
            { name: 85, last: 55, avg: 55 },
            { name: 60, last: 52, avg: 52 },
            { name: 78, last: 50, avg: 50 },
            { name: 45, last: 55, avg: 55 },
          ].map((row, index) => (
            <div className="workflow-dashboard-table-row" key={index}>
              <span>
                <Skeleton width={`${row.name}%`} height={13} />
              </span>
              <span>
                <Skeleton width={row.last} height={13} />
              </span>
              <span>
                <Skeleton width={row.avg} height={13} />
              </span>
            </div>
          ))}
          <div className="workflow-dashboard-table-row workflow-dashboard-total">
            <span>
              <Skeleton width={38} height={13} />
            </span>
            <span>
              <Skeleton width={60} height={13} />
            </span>
            <span>
              <Skeleton width={60} height={13} />
            </span>
          </div>
        </div>
        <h3>Machines Use in this Workflow</h3>
        <div className="workflow-dashboard-table workflow-usage-table">
          <div className="workflow-dashboard-table-head">
            <span>Machines</span>
            <span>Usage Type</span>
          </div>
          {[
            { name: 55, type: 35 },
            { name: 80, type: 35 },
            { name: 72, type: 35 },
            { name: 70, type: 35 },
            { name: 45, type: 35 },
          ].map((row, index) => (
            <div className="workflow-dashboard-table-row" key={index}>
              <span>
                <Skeleton width={`${row.name}%`} height={13} />
              </span>
              <span>
                <Skeleton width={row.type} height={13} />
              </span>
            </div>
          ))}
        </div>
      </>
    );
  } else {
    return (
      <div className="skeleton">
        <Skeleton count={count} height={lineheight} />
      </div>
    );
  }
}
export default Loader;
